import { Component, OnInit, Input } from '@angular/core';
import { NzModalService, NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SparepartsService } from '../../../service/spareparts.service';
// import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { SpareListComponent } from '../../spareparts-management/spare-list/spare-list.component';

@Component({
  selector: 'app-out-detail',
  templateUrl: './out-detail.component.html',
  styleUrls: ['./out-detail.component.less']
})
export class OutDetailComponent implements OnInit {

  validateForm: FormGroup;
  selectedValue: string;
  listOfData: ItemData[] = [];
  editId: string | null = null;
  outNo: string;
  uploading = false;
  loading = false;
  canSave = false;
  @Input() outTypes: any;
  @Input() no: string;
  @Input() typeId: number;
  @Input() receiver: string;
  @Input() description: string;
  @Input() rlNo: string;
  users = [];
  outDescription: string;
  nzFilterOption = () => true;
  constructor(
    private fb: FormBuilder,
    private modalRef: NzModalRef,
    private modal: NzModalService,
    public message: NzMessageService,
    private dataService: SparepartsService,
  ) { }

  ngOnInit(): void {
    if (this.no != null) {
      this.canSave = true;
      this.validateForm = this.fb.group({
        typeId: new FormControl({ value: this.typeId, disabled: true }, Validators.required),
        outNo: new FormControl({ value: this.no, disabled: true }, Validators.required),
        receiver: new FormControl({ value: this.receiver, disabled: true }, Validators.required),
        rlNo: new FormControl({ value: this.rlNo, disabled: true }, Validators.required),
      });
      this.outNo = this.no;
      this.selectedValue = this.typeId + '';
      this.receiver = this.receiver;
      this.outDescription = this.description;
      this.queryEntryDetailData();
    } else if (this.rlNo != null) {
      // this.search(this.receiver);
      this.validateForm = this.fb.group({
        typeId: new FormControl({ value: this.typeId, disabled: true }, Validators.required),
        outNo: new FormControl({ value: this.outNo, disabled: true }, Validators.required),
        receiver: new FormControl({ value: this.receiver, disabled: false }, Validators.required),
        rlNo: new FormControl({ value: this.rlNo, disabled: true }, Validators.required),
      });
      this.selectedValue = this.typeId + '';
      this.initEntryNo();
      this.queryTakeSpareDetailData();
    } else {
      this.validateForm = this.fb.group({
        typeId: new FormControl({ value: null, disabled: false }, Validators.required),
        outNo: new FormControl({ value: this.outNo, disabled: true }, Validators.required),
        receiver: new FormControl({ value: null, disabled: false }, Validators.required),
        rlNo: new FormControl({ value: this.rlNo, disabled: true }, Validators.required),
      });
      // this.fb.group({ typeId: null, outNo: null, receiver: null });
      this.initEntryNo();
    }

  }



  initEntryNo() {
    const nowstr = new Date();
    this.outNo = nowstr.getFullYear()
      + ((nowstr.getMonth() + 1) < 10 ? '0' : '') + (nowstr.getMonth() + 1)
      + (nowstr.getDate() < 10 ? '0' : '') + nowstr.getDate()
      + (nowstr.getHours() < 10 ? '0' : '') + nowstr.getHours()
      + (nowstr.getMinutes() < 10 ? '0' : '') + nowstr.getMinutes()
      + (nowstr.getSeconds() < 10 ? '0' : '') + nowstr.getSeconds();
  }

  /**
   * 查询领料单详情
   */
  async queryTakeSpareDetailData() {
    this.loading = true;
    const result = await this.dataService.queryTakeSpareDetailData(this.rlNo);
    this.loading = false;
    if (result === null) {
      return;
    } else {
      result.list.forEach(element => {
        // element.total = element.price * element.amount;
        element.requireAmount = element.amount;
      });
      this.listOfData = result.list;
      this.users = [{
        userName: result.info.applicantName,
        userId: result.info.applicant
      }];
      this.receiver = result.info.applicant;
    }
  }
  addSpare() {
    const modal = this.modal.create({
      nzTitle: '备件列表',
      nzContent: SpareListComponent,
      nzStyle: { top: '40px' },
      nzWidth: 800,
      nzMaskClosable: false,
      nzFooter: null,
      nzComponentParams: {
        code: 1, // code 0 备件只能查看，不能选择 code 1 备件可以查看 也可以被选中
      }
    });
    modal.afterClose.subscribe(
      {
        next: items => {
          // console.log(items);
          if (items != null && items !== undefined) {
            items.forEach(element => {
              const index = this.listOfData.findIndex((a) => a.spNo === element.spNo);
              if (index < 0) {
                this.listOfData = [
                  ...this.listOfData,
                  {
                    spNo: element.spNo,
                    spName: element.spName,
                    amount: 0,
                    stocks: element.amount,
                    price: element.price,
                    unit: element.unit,
                    total: 0,
                    desc: element.mark
                  }
                ];
              }
            });
          }

        }
      }
    );
  }

  async queryEntryDetailData() {
    this.loading = true;
    const result = await this.dataService.queryOutDetailData(this.no);
    this.loading = false;
    if (result.code !== 200) {
      this.message.create('error', '查询出库详情失败!');
      return;
    } else {
      result.data.forEach(element => {
        element.total = element.price * element.amount;
        element.stocks = element.amount + 1; // 仅是为了用来显示“数量”列判断的，没有其他用处
      });
      this.listOfData = result.data;
    }
  }
  exportForm() {
    if (this.listOfData == null || this.listOfData.length === 0) {
      return;
    }
    const dataToExport: any[] = [];
    let index = 0;
    this.listOfData.forEach(e => {
      index = index + 1;
      const item = {
        '序号': index,
        '备件名称': e.spName,
        '数量': e.amount,
        '单位': e.unit,
        '备注': e.desc
      };
      dataToExport.push(item);
    });
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook: XLSX.WorkBook = { Sheets: { '出库单': worksheet }, SheetNames: ['出库单'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    const nowstr = new Date();
    const datenow = nowstr.getFullYear()
      + ((nowstr.getMonth() + 1) < 10 ? '0' : '') + (nowstr.getMonth() + 1)
      + (nowstr.getDate() < 10 ? '0' : '') + nowstr.getDate()
      + (nowstr.getHours() < 10 ? '0' : '') + nowstr.getHours()
      + (nowstr.getMinutes() < 10 ? '0' : '') + nowstr.getMinutes()
      + (nowstr.getSeconds() < 10 ? '0' : '') + nowstr.getSeconds();
    // FileSaver.saveAs(data, '出库单' + '_' + datenow + '.xlsx');
  }
  deleteRows(id: number): void {
    this.listOfData = this.listOfData.filter(d => d.spNo !== id);
  }
  startEdit(id: string): void {
    this.editId = id;
  }

  stopEdit(data: any): void {
    if (data.amount < 0) {
      data.amount = 0;
    }
    data.total = data.amount * data.price;
    this.editId = null;
  }

  async saveOutData() {
    if (this.outNo == null || this.outNo === undefined || this.outNo.toString() === '') {
      this.message.create('warning', '请输入出库单号!');
      return;
    }
    if (this.selectedValue == null || this.selectedValue === undefined || this.selectedValue.toString() === '') {
      this.message.create('warning', '请选择出库类型!');
      return;
    }
    if (this.receiver == null || this.receiver === undefined || this.receiver.toString().trim() === '') {
      this.message.create('warning', '请输入并选择领用人!');
      return;
    }
    if (this.listOfData == null || this.listOfData.length === 0) {
      this.message.create('warning', '请添加备件信息!');
      return;
    }
    // if (!this.listOfData.every(data => data.amount > 0)) {
    //   this.message.create('warning', '出库备件数量不能等于0!');
    //   return;
    // }
    if (!this.listOfData.every(data => data.amount <= data.stocks)) {
      this.message.create('warning', '出库备件数量不能大于当前库存数量!');
      return;
    }
    if (!this.listOfData.every(data => (data.desc == null || data.desc === undefined || data.desc.trim().length <= 50))) {
      this.message.create('warning', '备件的备注信息字数不能大于50!');
      return;
    }
    if (this.outDescription != null && this.outDescription !== undefined && this.outDescription.trim().length > 100) {
      this.message.create('warning', '出库单备注信息字数不能大于100!');
      return;
    }
    if (this.outDescription === undefined) {
      this.outDescription = '';
    }
    this.modal.confirm({
      nzTitle: '<i>确认出库备件数量等信息无误并创建出库单？</i>',
      // nzContent: '<b>保存？</b>',
      nzOnOk: () => this.saveOutDataInfo()
    });
  }
  async saveOutDataInfo() {
    this.uploading = true;
    const result =
      await this.dataService.uploadOutSparePartsData(this.outNo, this.selectedValue, this.receiver,
        this.listOfData, this.outDescription, this.rlNo);
    this.uploading = false;
    if (result === null) {
      this.message.create('error', '出库失败!');
    } else {
      this.message.create('success', '出库成功!');
      this.modalRef.destroy('success');
    }
  }
  cancleEntryData() {
    this.modalRef.destroy('cancle');
  }

  async search(value: string) {
    if (value == null || value === undefined || value.trim() === '') {
      return;
    }
    const userResult = await this.dataService.queryUserList(value.trim());
    if (userResult === null) {
      return;
    } else {
      this.users = userResult;
    }
  }

}
interface ItemData {
  spNo: number;
  spName: string;
  amount: number;
  unit: string;
  price: number;
  total: number;
  desc: string;
  stocks: number;
}
